import {useSelector} from 'react-redux';
import {HibuKeycloakConfig} from './config-types';

export function useSpotlightTagTypes() {
    return useSelector(state => state.config.search.spotlightTagTypes);
}

export function useSharedSavedSearchesEnabled() {
    return useSelector((state) => state.config.sharedSavedSearches.enabled);
}

export function useKeycloakConfig(): HibuKeycloakConfig {
    return useSelector((state) => state.config.keycloakConfig);
}
